export default () => {
    const items = document.querySelectorAll<HTMLUListElement>('.color-variable-item')

    items.forEach((item: HTMLUListElement) => {
        item.addEventListener('mouseenter', () => {
            const color = item.querySelector('.variable-item-span-color')

            if (color) {
                const style = window.getComputedStyle(color)
                const backgroundColor = style.backgroundColor;

                item.style.setProperty('--item-before-background-color', backgroundColor)
            }
        })

        item.addEventListener('mouseleave', () => {
            item.style.removeProperty('--item-before-background-color');
        })
    });
}
